<section
  class="quote-details"
  [attr.aria-label]="'Quote details for ' + vendorName()"
>
  <!-- Back button -->
  <button
    type="button"
    class="quote-details__back"
    (click)="back.emit()"
    aria-label="Go back to estimates list"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="5"
      height="8"
      viewBox="0 0 5 8"
      fill="none"
    >
      <path
        d="M4 8L0 4L4 0L4.93333 0.933333L1.86667 4L4.93333 7.06667L4 8Z"
        fill="#D0006F"
      />
    </svg>
    Back
  </button>

  <!-- Header: vendor name + download link -->
  <div class="quote-details__header">
    <h3 class="quote-details__vendor-name">{{ vendorName() }}</h3>
    <button
      type="button"
      class="quote-details__download"
      aria-label="View Quote PDF"
      (click)="generateQuotePDF()"
    >
      View Quote PDF
    </button>
  </div>

  <!-- Job Requirement Change Banner -->
  @if (hasAnyReclassification()) {
    <div
      class="quote-details__reclassification-banner"
      role="alert"
      data-testid="job-requirement-change-banner"
    >
      <mat-icon class="quote-details__banner-icon" aria-hidden="true">info</mat-icon>
      <p class="quote-details__banner-text">
        <strong>Job Requirement Change:</strong> While reviewing your files for
        translation, the vendor identified some changes regarding Desktop
        Publishing needs. If you select this quote, these changes will be
        reflected in the Job Details tab. For more details please expand the
        Document Requirement Changes accordion.
      </p>
    </div>
  }

  <!-- Quote cards per delivery type -->
  <div class="detail-wrapper">
    @for (row of rows(); track row.jobType) {
      <article class="quote-details__card">
        <!-- Info header -->
        <div class="quote-details__info">
          <div class="quote-details__info-col">
            <span class="quote-details__info-label">Delivery type</span>
            <span class="quote-details__info-value">
              <svg
                class="quote-details__clock-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M10.1839 18.3886C9.03114 18.3886 7.94781 18.1698 6.93392 17.7323C5.92003 17.2948 5.03809 16.7011 4.28809 15.9511C3.53809 15.2011 2.94434 14.3191 2.50684 13.3052C2.06934 12.2913 1.85059 11.208 1.85059 10.0552C1.85059 8.90245 2.06934 7.81912 2.50684 6.80523C2.94434 5.79134 3.53809 4.90939 4.28809 4.15939C5.03809 3.40939 5.92003 2.81564 6.93392 2.37814C7.94781 1.94064 9.03114 1.72189 10.1839 1.72189C11.3367 1.72189 12.42 1.94064 13.4339 2.37814C14.4478 2.81564 15.3298 3.40939 16.0798 4.15939C16.8298 4.90939 17.4235 5.79134 17.861 6.80523C18.2985 7.81912 18.5173 8.90245 18.5173 10.0552C18.5173 10.4302 18.4964 10.7983 18.4548 11.1594C18.4131 11.5205 18.3436 11.8747 18.2464 12.2219C18.052 11.9997 17.8263 11.8122 17.5693 11.6594C17.3124 11.5066 17.0311 11.4024 16.7256 11.3469C16.7673 11.1386 16.7985 10.9268 16.8193 10.7115C16.8402 10.4962 16.8506 10.2774 16.8506 10.0552C16.8506 8.19412 16.2048 6.61773 14.9131 5.32606C13.6214 4.03439 12.045 3.38856 10.1839 3.38856C8.32281 3.38856 6.74642 4.03439 5.45475 5.32606C4.16309 6.61773 3.51725 8.19412 3.51725 10.0552C3.51725 11.9163 4.16309 13.4927 5.45475 14.7844C6.74642 16.0761 8.32281 16.7219 10.1839 16.7219C10.8923 16.7219 11.5693 16.6177 12.2152 16.4094C12.861 16.2011 13.4548 15.9094 13.9964 15.5344C14.1631 15.7705 14.3679 15.9788 14.611 16.1594C14.8541 16.3399 15.1145 16.4788 15.3923 16.5761C14.6839 17.1455 13.8888 17.5899 13.0068 17.9094C12.1249 18.2288 11.1839 18.3886 10.1839 18.3886ZM16.2256 15.0552C15.9339 15.0552 15.6874 14.9545 15.486 14.7531C15.2846 14.5518 15.1839 14.3052 15.1839 14.0136C15.1839 13.7219 15.2846 13.4754 15.486 13.274C15.6874 13.0726 15.9339 12.9719 16.2256 12.9719C16.5173 12.9719 16.7638 13.0726 16.9652 13.274C17.1666 13.4754 17.2673 13.7219 17.2673 14.0136C17.2673 14.3052 17.1666 14.5518 16.9652 14.7531C16.7638 14.9545 16.5173 15.0552 16.2256 15.0552ZM12.9339 13.9719L9.35059 10.3886V5.88856H11.0173V9.72189L14.1006 12.8052L12.9339 13.9719Z"
                  fill="#333333"
                />
              </svg>
              {{ row.jobType }}
            </span>
          </div>
          <div class="quote-details__info-col">
            <span class="quote-details__info-label">Delivery date</span>
            <span
              class="quote-details__info-value quote-details__info-value--bold"
              >{{ row.deliveryDate }}</span
            >
          </div>
          <div
            class="quote-details__info-col quote-details__info-col--quote-id"
          >
            <span class="quote-details__info-label">Quote ID</span>
            <span
              class="quote-details__info-value quote-details__info-value--bold"
              >{{ quoteId() }}</span
            >
          </div>
          @if (showSelectQuote()) {
            <div
              class="quote-details__info-col quote-details__info-col--action"
            >
              <app-vendor-select-btn
                [order]="order()!"
                [estimate]="estimate()"
                [hasLowestRate]="isLowestRate()"
                (quoteConfirmed)="quoteConfirmed.emit($event)"
              />
            </div>
          }
        </div>

        <!-- Cost breakdown -->
        @if (getCostBreakdown(row.quote).length) {
          <div class="quote-details__breakdown">
            @for (item of getCostBreakdown(row.quote); track item.concept) {
              <div class="quote-details__breakdown-row">
                <p class="quote-details__breakdown-concept">
                  {{
                    item.concept === "Translation cost"
                      ? "Estimated linguistic review"
                      : item.concept
                  }}
                </p>
                <span class="quote-details__breakdown-cost">{{
                  item.cost | formatCurrency: currency()
                }}</span>
              </div>
            }
          </div>
        }

        <!-- Total cost -->
        <div class="quote-details__total">
          <div class="quote-details__total-label">Total cost</div>
          <div class="quote-details__total-value">
            {{ getTotalCost(row.quote) | formatCurrency: currency() }}
          </div>
        </div>
        <p class="quote-details__buffer-note">
          <strong>Note:</strong> Add a 15% buffer to your purchase order to
          account for potential adjustments in currency, tax, or review costs
          after file preparation.
        </p>
        <div class="quote-details__recommended">
          <span class="quote-details__recommended-label"
            >Recommended PO total</span
          >
          <span class="quote-details__recommended-value">
            <span class="quote-details__recommended-pct">+15%</span>=
            {{ getRecommendedPOTotal(row.quote) | formatCurrency: currency() }}
          </span>
        </div>
      </article>
    }
    <div class="blank-space"></div>
  </div>

  <!-- Document Requirement Changes section -->
  <app-document-requirement-changes
    [detail]="vendorJobDetails()"
    data-testid="quote-details-reclassification-section"
  />
</section>
